import { render, staticRenderFns } from "./StoredCarts.vue?vue&type=template&id=3f5fb02a&"
import script from "./StoredCarts.vue?vue&type=script&lang=js&"
export * from "./StoredCarts.vue?vue&type=script&lang=js&"
import style0 from "./StoredCarts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports